var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + ((null == (pug_interp = require("./hero.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./gdpr-intro.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./list-module-01.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./right-tool.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./be-compliant.pug").call(this, locals)) ? "" : pug_interp) + (null == (pug_interp = require("./try-banner.pug").call(this, locals)) ? "" : pug_interp));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/gdpr/view/index.pug
// module id = 1089
// module chunks = 0